
import {
    Component,
    Vue,
    Watch
} from 'vue-property-decorator';
import abnormalDataEntity from '@/Areas/AppAreaName/Views/intellpension/healthservice/entity/abnormalEntity';
import $ from 'jquery';
@Component({
    sockets: {
        newmes(r) {
            // console.log(r);
            if (this.$store.state.session.remindAudio) {
                this.$Notice.info({
                    title: r.usename + '发来消息',
                    desc: r.mes
                })
                //  this.windowDouDong();
                this.plays();
            }
        }
    }
})
export default class App extends Vue {
    screenHeight = document.documentElement.clientHeight;
    screenWidth = document.documentElement.clientWidth;
    abnormalEnd: abnormalDataEntity = new abnormalDataEntity();
    userIdNameList: Array < any >= new Array < any > ();
    @Watch('abnormalEnd', {
        deep: true
    })
    changeAbnormalEndRecord(newVal, oldVal) {
        if (newVal.abnormal_Data.tO_TIME === oldVal.abnormal_Data.tO_TIME) {
            //同一条
        } else {
            this.$Notice.info({
                title: '有新的异常数据请留意',
                desc: this.userIdNameList[newVal.abnormal_Data.userid] + ':' + newVal.abnormal_Data.abnormaL_DIA
            })
        }
    };
    plays() {
        let audio = document.querySelector('#audio');
        audio.play()
    }
    windowDouDong() {
        var a = ['top', 'left'],
            b = 0;
        var u;
        u = setInterval(function () {
            // console.log(document.getElementById('app'))
            document.getElementById('app').style[a[b % 2]] = (b++) % 4 < 2 ? 0 : 4;
            if (b > 15) {
                clearInterval(u);
                b = 0
            }
        }, 32)
    }
    bodyScale() {
        var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
        var scale = devicewidth / 1920; // 分母——设计稿的尺寸
        document.body.style.zoom = scale;//放大缩小相应倍数
    }

    async getAbnormalEndRecord() {
        await this.$store.dispatch({
            type: 'abnormal/getlistRecent'
        }).then(result => {
            this.abnormalEnd = result;
        })
    }
    mounted() {
        // this.bodyScale();
        let docEl = document.documentElement;
       if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth < 1600) {
            docEl.style.fontSize = '12px';
            $('.topListItem').css('line-height', '3rem');
         
        } else if (document.documentElement.clientWidth >= 1600) {
            docEl.style.fontSize = '18px';
            $('.topListItem').css('line-height', '2rem');
          
        }else{
            console.log('iam here')
            docEl.style.fontSize = '12px';
           
            $('.topListItem').css('line-height', '2rem');
            
        }
        $('#app').css('height', this.screenHeight);
        $('#app').css('width', this.screenWidth);
        window.onresize = () => {
            return (() => {
                // this.bodyScale();
                $('#app').css('height', document.documentElement.clientHeight);
                $('#app').css('width', document.documentElement.clientWidth);
                if (document.documentElement.clientWidth >= 1200 && document.documentElement.clientWidth < 1600) {
                    docEl.style.fontSize = '12px';
                    $('.topListItem').css('line-height', '3rem');
                } else if (document.documentElement.clientWidth >= 1600) {
                    docEl.style.fontSize = '18px';
                    $('.topListItem').css('line-height', '2rem');
                }else if(document.documentElement.clientWidth < 1000){
                    docEl.style.fontSize = '10px';
                    $('.topListItem').css('line-height', '2rem');
                }else{
                    docEl.style.fontSize = '12px';
                    $('.topListItem').css('line-height', '2rem');
                }
            })()
        };
        this.userIdNameList = JSON.parse(localStorage.getItem('userIdActulnameList'));
        setInterval(() => {
            //  this.getAbnormalEndRecord();
        }, 3000);
        if (this.isMobile()) {
            // this.$router.push("/phoneIndex");
        }
        
        // this.$Notice.open({
        //     title: 'Notification title',
        //     desc: 'This notification does not automatically close, and you need to click the close button to close.',
        //     duration: 0,
        // });
        // this.$Notice.open({
        //     title: 'Notification title',
        //     desc: 'This notification does not automatically close, and you need to click the close button to close.',
        //     duration: 0
        // });
    }
    isMobile() {
        let flag = navigator.userAgent.match( // match方法可在字符串内检索指定的值，
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        // console.log(flag)
        return flag;
    }
}
